<script type="text/jsx">
import { get, linkTo } from '@lsfe/tools';

import vRemote from './Remote';

export default {
    name: 'CardInfo',
    components: {
        vRemote,
    },
    props: {
        span: {
            type: Number,
            default: 0,
        },
        gutter: {
            type: Number,
            default: 0,
        },
        data: {
            type: Object,
            required: true,
        },
        configs: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        lines() {
            return this.configs.map((item) => this.getValueByProp(this.data, item));
        },
    },
    methods: {
        getValueByProp(data, item) {
            const val = get(data, item.prop, '');
            if (Array.isArray(item)) {
                return item.map((it) => this.getValueByProp(this.data, it));
            }
            if (item.formatter) {
                return {
                    ...item,
                    value: item.formatter(val, this.customerInfo),
                };
            }
            return {
                ...item,
                originVal: val,
                value: [undefined, null, ''].includes(val) ? '--' : val,
            };
        },
        jumToUrl(col) {
            const { originVal, value, message } = col;
            if (originVal) {
                return linkTo(value, {}, true);
            }
            // eslint-disable-next-line no-alert
            return window.alert(message || '暂无信息');
        },
        renderColValue(col) {
            if (Array.isArray(col)) {
                return this.renderLineValue(col, -1);
            }
            if (col.type === 'dicCode') {
                return (
                    <xx-form-item label={col.label}>
                        <xx-enum-text props={{ dicCode: col.dicCode, value: col.value }} />
                    </xx-form-item>
                );
            }
            if (col.type === 'remote') {
                return (
                    <xx-form-item label={col.label}>
                        <v-remote props={{ remoteConfig: col.remoteConfig, value: col.value }} />
                    </xx-form-item>
                );
            }
            if (col.type === 'url') {
                return (
                    <xx-form-item label={col.label}>
                        <el-button onClick={() => this.jumToUrl(col)} type={col.btnType || 'text'}>{col.btnName || ''}</el-button>
                    </xx-form-item>
                );
            }
            if (col.type === 'date') {
                return (
                    <xx-form-item label={col.label}>
                        {this.$tools.formatTime(col.value, col.format || 'YYYY-MM-DD HH:mm:ss')}
                    </xx-form-item>
                );
            }
            return (
                <xx-form-item label={col.label} class={col.className || ''}>
                    {col.value}
                </xx-form-item>
            );
        },
        renderLineValue(line, index, level) {
            if (Array.isArray(line)) {
                return (
                    <el-row key={`line-${index}`} gutter={this.gutter}>{(line.map((col, index2) => (
                        col.visible === false ? '' : <el-col key={`col-${index}-${index2}`} span={(level === 1 && this.span > 0) ? this.span : 24 / line.length}>{this.renderColValue(col)}</el-col>
                    )))}</el-row>
                );
            }
            return (
                <el-row key={`line-${index}`}>
                    {line.visible === false ? '' : <el-col props={{ ...(line.props || {}) }} {...(line.attrs || {})} span={24}>{this.renderColValue(line)}</el-col>}
                </el-row>
            );
        },
    },
    render() {
        return (
            <xx-form props={{ ...(this.$attrs || {}) }} class="card-info">{this.lines.map((line, index) => this.renderLineValue(line, index, 1))}</xx-form>
        );
    },
};
</script>

<style lang="scss" scoped>
.control {
    text-align: center;
}
.canClick {
    color: #409eff;
    cursor: pointer;
}

/deep/ .el-form-item {
    margin-bottom: 0;
}
</style>
